import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "f540b10a-c1f3-4fe7-a94b-12bde907d3ec", content: "The density of the medium increases", options: {} },
  { id: "408948ac-42d0-4efe-b0cc-e94c2159606d", content: "Atmospheric pressure decreases", options: {} },
  { id: "4a170902-6259-47fa-acff-dc2ad0ee3bdf", content: "The density  of the medium decreases", options: {} },
  { id: "8f78668f-1c4a-492a-9560-83cf1b3935aa", content: "Atmospheric pressure increases", options: {} },
];

export const task: Task = {
  id: "868fa2e4-6886-4bde-9dee-fee31046a905",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4a170902-6259-47fa-acff-dc2ad0ee3bdf", "8f78668f-1c4a-492a-9560-83cf1b3935aa"],
};
